export default __webpack_public_path__ + "static/media/Bollfilter.09307a74.png";